import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';

import DocComponent from 'pages/Entrepeneur/Feedbacks/Miscellaneous/DocComponent';
import NewComment from '../FeedBackCard/NewComment';

const useStyles = makeStyles({
  root: {
    minWidth: 675,
    margin: '1rem 0',
    padding: 7
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: {
    fontSize: 12,
    fontFamily: 'PT sans',
    background: '#C5FAE5',
    color: '#22BF80',
    FontWeight: 'bolder',
    border: '1px solid #C5FAE5',
    borderRadius: 11,
    padding: '0 9px'
  },
  name: {
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: 14,
    color: '#252525'
  },
  status: {
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#A7AAAE'
  },
  time: {
    fontFamily: 'PT sans',
    fontSize: '14px',
    color: '#252523'
  },
  text: {
    marginTop: 15,
    marginBottom: 10,
    fontFamily: 'PT sans',
    fontSize: '16px'
  },
  detail: {
    fontFamily: 'PT sans',
    fontWeight: 'bold',
    fontSize: '16px',
    color: '#A7AAAE'
  },
  message: {
    marginTop: 10,
    fontWeight: '600'
  },
  meet: {
    color: '#0E4EAD',
    fontWeight: 'bold'
  },

  nameContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 15
  },
  avatar: {
    marginTop: 10,
    marginRight: 10
  },
  buttonContainer: {
    margin: '0 10',
    textAlign: 'right'
  },
  button: {
    textTransform: 'lowercase',
    fontWeight: 'bold'
  }
});

const DocumentCard = ({
  showComments,
  name,
  status,
  time,
  avatar,
  text,
  company,
  docName,
  showButton,
  click
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.root} elevation={0}>
      <CardContent>
        <div className={classes.container}>
          <Typography className={classes.title} gutterBottom>
            Document
          </Typography>
          <Typography className={classes.time} gutterBottom>
            {time}
          </Typography>
        </div>
        <div className={classes.nameContainer}>
          <Avatar className={classes.avatar} src={avatar}>
            {!avatar && name.charAt(0)}
          </Avatar>
          <div>
            <Typography className={classes.name} component="h2" variant="h5">
              {name}
            </Typography>
            <Typography className={classes.status}>{status}</Typography>
          </div>
        </div>
        <Typography className={classes.text}>
          {text} <span className={classes.meet}>{company}</span>
        </Typography>
        {docName && <DocComponent click={click} docName={docName} fullWidth />}
        {showButton && (
          <div className={classes.buttonContainer}>
            <Button
              className={classes.button}
              color="primary"
              variant="contained">
              Share with investors
            </Button>
          </div>
        )}
      </CardContent>

      <NewComment />
    </Card>
  );
};

export default DocumentCard;
